module.exports = __webpack_public_path__ + "static/media/emojis2_17.775e5d0e.svg";